/*
 * Copyright (c) 2025 NoorWays. All rights reserved.
 * Licensed under the terms specified in the LICENSE.txt file.
 */

import { getConfigValue } from './runtimeConfig'

/**
 * Application configuration for NoorWays.Writer web client
 */
export interface AppConfig {
  /** Backend API base URL */
  apiBaseUrl: string
  /** Stripe publishable key for payment processing */
  stripePublishableKey: string
  /** Subscription plans configuration */
  subscription: {
    maxFreeUsage: number
  }
}

/**
 * Default application configuration
 * Values are resolved from environment variables with optional defaults
 */
const appConfig: AppConfig = {
  // API configuration
  get apiBaseUrl(): string {
    return getConfigValue('VITE_API_BASE_URL', '') || ''
  },

  // Stripe configuration
  get stripePublishableKey(): string {
    return getConfigValue('VITE_STRIPE_PUBLISHABLE_KEY', '') || ''
  },

  // Subscription configuration
  subscription: {
    maxFreeUsage: 10
  }
}

export default appConfig
